import {useAtom} from "jotai";
import React, {
  useEffect,
  useState
} from "react";
import styled from "styled-components";
import {
  useForm
} from "react-hook-form";

import {
  ModalBody,
  ModalHeader
} from "../modal/Modal";
import {
  modalController
} from "../../store";
import {
  selKeywordUser
} from "../../services/Platform/ManageUserAxios";
import {
  addHistory,
  adverPointeRquest
} from "../../services/payment/admin/PointAllListRequestAxios";
import {
  decimalFormat,
  removeStr
} from "../../common/StringUtils";

const HISTORY_TITLE = "광고비 지급/차감";

const PAYMENT_METHOD = {
  GIVE: "GIVEN_BY_ADMIN",
  TAKE: "TAKEN_BY_ADMIN"
};

export function SearchAdvertiser({
  title,
  onSubmit,
  btnStyle,
  historyAdd
}) {
  const [, setModal] = useAtom(
      modalController
  );

  useEffect(() => {
    return () => {
      setModal({
        isShow: false
      });
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleOpenModal = () => {
    setModal({
      isShow: true,
      width:
          historyAdd !== undefined
              ? 760
              : '',
      modalComponent: () => (
          <SearchModal
              title={title}
              onSubmit={onSubmit}
              historyAdd={historyAdd}
          />
      )
    });
  };

  if (btnStyle === "historyAddButton") {
    return (
        <HistoryOpenButton
            type="button"
            className="listUp"
            onClick={handleOpenModal}
        >
          {title}
        </HistoryOpenButton>
    );
  }

  return (
      <SearchOpenButton
          type="button"
          onClick={handleOpenModal}
      >
        {title}
      </SearchOpenButton>
  );
}

function SearchModal({
  title,
  onSubmit
}) {
  const [, setModal] = useAtom(
      modalController
  );

  const [advertisers, setAdvertisers] =
      useState([]);

  const [selectedItem, setSelectedItem] =
      useState(null);

  const [searchKeyword, setSearchKeyword] =
      useState("");

  const [historyState, setHistoryState] =
      useState(false);

  const [paymentMethod, setPaymentMethod] =
      useState(PAYMENT_METHOD.GIVE);

  const [enterAmount, setEnterAmount] =
      useState(0);

  const [advertiserPoint, setAdvertiserPoint] =
      useState(0);

  const [note, setNote] = useState("");
  const [validation, setValidation] =
      useState("");
  const [isSearching, setIsSearching] =
      useState(false);
  const [isLoadingPoint, setIsLoadingPoint] =
      useState(false);
  const [isSaving, setIsSaving] =
      useState(false);

  const {
    register,
    handleSubmit,
    setError,
    clearErrors,
    formState: {errors}
  } = useForm();

  const modalTitle = title ?? "검색";
  const isHistoryMode =
      title === HISTORY_TITLE;

  useEffect(() => {
    handleSearch();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const closeModal = () => {
    setModal({
      isShow: false,
      modalComponent: null
    });
  };

  const handleSelect = item => {
    setSelectedItem(item);
    setValidation("");
  };

  const handleChangeAmount = value => {
    const numberValue = Number(
        removeStr(value)
    );

    setEnterAmount(numberValue);
    clearErrors("enterAmount");
  };

  const handleChangeKeyword = event => {
    const regExp =
        /[{}\[\]/?.,;:|)*~`!^\-_+<>@#$%&\\=('\"]/g;

    if (!regExp.test(event.target.value)) {
      setSearchKeyword(
          event.target.value
      );
    }
  };

  const handleSearch = async () => {
    if (isSearching || historyState) {
      return;
    }

    setIsSearching(true);
    setSelectedItem(null);

    try {
      const response =
          await selKeywordUser(
              searchKeyword
          );

      const result = Array.isArray(response)
          ? response
          : [];

      setAdvertisers(result);
      setValidation(
          result.length > 0
              ? ""
              : "검색된 광고주가 존재하지 않습니다."
      );
    } catch (error) {
      console.error(
          "광고주 검색 실패:",
          error
      );

      setAdvertisers([]);
      setValidation(
          "광고주 검색 중 오류가 발생했습니다."
      );
    } finally {
      setIsSearching(false);
    }
  };

  const handleSearchKeyDown = event => {
    if (event.key !== "Enter") {
      return;
    }

    event.preventDefault();
    handleSearch();
  };

  const handleConfirmAdvertiser = async () => {
    if (!selectedItem?.id) {
      setValidation(
          "광고주를 선택해주세요."
      );
      return;
    }

    if (!isHistoryMode) {
      closeModal();
      onSubmit?.(selectedItem);
      return;
    }

    setIsLoadingPoint(true);

    try {
      const response =
          await adverPointeRquest(
              selectedItem.id
          );

      setAdvertiserPoint(
          Number(
              response?.availablePoint ?? 0
          )
      );
      setHistoryState(true);
      setValidation("");
    } catch (error) {
      console.error(
          "광고비 잔액 조회 실패:",
          error
      );

      setValidation(
          "광고비 잔액을 조회하는 중 오류가 발생했습니다."
      );
    } finally {
      setIsLoadingPoint(false);
    }
  };

  const handleBackToSearch = () => {
    setHistoryState(false);
    setEnterAmount(0);
    setNote("");
    clearErrors();
  };

  const submitHistory = async () => {
    if (isSaving) {
      return;
    }

    if (enterAmount <= 0) {
      setError("enterAmount", {
        type: "required",
        message:
            "요청 금액을 입력해 주세요."
      });
      return;
    }

    if (
        paymentMethod === PAYMENT_METHOD.TAKE &&
        enterAmount > advertiserPoint
    ) {
      setError("enterAmount", {
        type: "validate",
        message:
            "요청 금액이 광고비 잔액을 초과합니다."
      });
      return;
    }

    setIsSaving(true);

    try {
      await addHistory({
        userId: selectedItem.id,
        pointHistoryType:
        paymentMethod,
        point:
            paymentMethod ===
            PAYMENT_METHOD.GIVE
                ? enterAmount
                : -enterAmount,
        description: note
      });

      onSubmit?.();
      setEnterAmount(0);
      closeModal();
    } catch (error) {
      console.error(
          "광고비 이력 추가 실패:",
          error
      );

      setValidation(
          "광고비 이력 처리 중 오류가 발생했습니다."
      );
    } finally {
      setIsSaving(false);
    }
  };

  const onError = formErrors => {
    console.error(
        "광고비 지급/차감 입력값 확인:",
        formErrors
    );
  };

  return (
      <ModalContainer>
        <ModalHeader title={modalTitle} />

        <ModalBody>
          {!historyState ? (
              <>
                <SectionHeader>
                  <div>
                    <SectionTitle>
                      광고주 검색
                    </SectionTitle>

                    <SectionGuide>
                      사업자명 또는 광고주명으로
                      캠페인을 생성할 광고주를
                      검색합니다.
                    </SectionGuide>
                  </div>

                  <ResultCount>
                    {advertisers.length}건
                  </ResultCount>
                </SectionHeader>

                <InnerBox>
                  <FieldRow>
                    <FieldLabel>
                      광고주 검색
                    </FieldLabel>

                    <FieldContent>
                      <SearchInputRow>
                        <SearchInput
                            type="text"
                            placeholder="사업자명/광고주명을 입력해주세요."
                            autoFocus
                            value={searchKeyword}
                            onChange={
                              handleChangeKeyword
                            }
                            onKeyDown={
                              handleSearchKeyDown
                            }
                        />

                        <SearchButton
                            type="button"
                            disabled={isSearching}
                            onClick={handleSearch}
                        >
                          {isSearching
                              ? "검색 중"
                              : "검색"}
                        </SearchButton>
                      </SearchInputRow>

                      <InputGuide>
                        검색 결과에서 광고주를
                        선택한 후 선택 완료 버튼을
                        눌러주세요.
                      </InputGuide>

                      {validation && (
                          <ValidationMessage>
                            {validation}
                          </ValidationMessage>
                      )}
                    </FieldContent>
                  </FieldRow>

                  <FieldRow>
                    <FieldLabel>
                      검색 결과
                    </FieldLabel>

                    <FieldContent>
                      <TableBox>
                        <TableHeader>
                          <span aria-hidden="true" />
                          <span>사업자명</span>
                          <span>광고주명</span>
                          <span>아이디</span>
                          <span>담당자명</span>
                        </TableHeader>

                        <TableBody>
                          {advertisers.length === 0 ? (
                              <EmptyResult>
                                {isSearching
                                    ? "광고주를 검색하고 있습니다."
                                    : "검색 결과가 없습니다."}
                              </EmptyResult>
                          ) : (
                              advertisers.map(
                                  (item, index) => {
                                    const selected =
                                        selectedItem?.id ===
                                        item.id;

                                    return (
                                        <TableRow
                                            key={
                                                item.id ??
                                                item.username ??
                                                index
                                            }
                                            type="button"
                                            $selected={
                                              selected
                                            }
                                            onClick={() =>
                                                handleSelect(
                                                    item
                                                )
                                            }
                                        >
                                          <SelectedMarkCell>
                                            <SelectedMark
                                                $selected={
                                                  selected
                                                }
                                                aria-hidden="true"
                                            />
                                          </SelectedMarkCell>

                                          <TableCell>
                                            {item.companyName ??
                                                "-"}
                                          </TableCell>

                                          <TableCell>
                                            {item.adverName ??
                                                "-"}
                                          </TableCell>

                                          <TableCell>
                                            {item.username ??
                                                "-"}
                                          </TableCell>

                                          <TableCell>
                                            {item.staffName ??
                                                "-"}
                                          </TableCell>
                                        </TableRow>
                                    );
                                  }
                              )
                          )}
                        </TableBody>
                      </TableBox>
                    </FieldContent>
                  </FieldRow>
                </InnerBox>

                <ModalFooter>
                  <SecondaryButton
                      type="button"
                      onClick={closeModal}
                  >
                    취소
                  </SecondaryButton>

                  <PrimaryButton
                      type="button"
                      disabled={
                          !selectedItem?.id ||
                          isLoadingPoint
                      }
                      onClick={
                        handleConfirmAdvertiser
                      }
                  >
                    {isLoadingPoint
                        ? "조회 중"
                        : isHistoryMode
                            ? "다음"
                            : "선택 완료"}
                  </PrimaryButton>
                </ModalFooter>
              </>
          ) : (
              <form
                  onSubmit={handleSubmit(
                      submitHistory,
                      onError
                  )}
              >
                <SectionHeader>
                  <div>
                    <SectionTitle>
                      광고비 지급/차감 설정
                    </SectionTitle>

                    <SectionGuide>
                      선택한 광고주의 광고비를
                      지급하거나 차감합니다.
                    </SectionGuide>
                  </div>
                </SectionHeader>

                <SelectedSummary>
                  <SelectedSummaryItem>
                    <SummaryLabel>
                      광고주명
                    </SummaryLabel>

                    <SummaryValue>
                      {selectedItem?.adverName ??
                          "-"}
                    </SummaryValue>
                  </SelectedSummaryItem>

                  <SelectedSummaryItem>
                    <SummaryLabel>
                      광고주 아이디
                    </SummaryLabel>

                    <SummaryValue>
                      {selectedItem?.username ??
                          "-"}
                    </SummaryValue>
                  </SelectedSummaryItem>

                  <SelectedSummaryItem>
                    <SummaryLabel>
                      현재 광고비 잔액
                    </SummaryLabel>

                    <SummaryValue $accent>
                      {decimalFormat(
                          advertiserPoint
                      )}
                      원
                    </SummaryValue>
                  </SelectedSummaryItem>
                </SelectedSummary>

                <InnerBox>
                  <FieldRow>
                    <FieldLabel>
                      지급/차감 설정
                    </FieldLabel>

                    <FieldContent>
                      <PaymentMethodGrid>
                        <PaymentMethodCard
                            $active={
                                paymentMethod ===
                                PAYMENT_METHOD.GIVE
                            }
                        >
                          <input
                              type="radio"
                              name="paymentMethod"
                              value={
                                PAYMENT_METHOD.GIVE
                              }
                              checked={
                                  paymentMethod ===
                                  PAYMENT_METHOD.GIVE
                              }
                              onChange={event =>
                                  setPaymentMethod(
                                      event.target.value
                                  )
                              }
                          />

                          <PaymentRadio
                              $active={
                                  paymentMethod ===
                                  PAYMENT_METHOD.GIVE
                              }
                          />

                          <PaymentMethodText>
                            <strong>
                              광고비 지급
                            </strong>
                            <span>
                          광고주 잔액에 입력한
                          금액을 추가합니다.
                        </span>
                          </PaymentMethodText>
                        </PaymentMethodCard>

                        <PaymentMethodCard
                            $active={
                                paymentMethod ===
                                PAYMENT_METHOD.TAKE
                            }
                        >
                          <input
                              type="radio"
                              name="paymentMethod"
                              value={
                                PAYMENT_METHOD.TAKE
                              }
                              checked={
                                  paymentMethod ===
                                  PAYMENT_METHOD.TAKE
                              }
                              onChange={event =>
                                  setPaymentMethod(
                                      event.target.value
                                  )
                              }
                          />

                          <PaymentRadio
                              $active={
                                  paymentMethod ===
                                  PAYMENT_METHOD.TAKE
                              }
                          />

                          <PaymentMethodText>
                            <strong>
                              광고비 차감
                            </strong>
                            <span>
                          광고주 잔액에서 입력한
                          금액을 차감합니다.
                        </span>
                          </PaymentMethodText>
                        </PaymentMethodCard>
                      </PaymentMethodGrid>
                    </FieldContent>
                  </FieldRow>

                  <FieldRow>
                    <FieldLabel>
                      금액 입력
                    </FieldLabel>

                    <FieldContent>
                      <AmountInputWrap>
                        <AmountInput
                            type="text"
                            maxLength={19}
                            inputMode="numeric"
                            {...register(
                                "enterAmount",
                                {
                                  required:
                                      "금액을 입력해 주세요.",
                                  pattern: {
                                    value: /^[0-9,]+$/,
                                    message:
                                        "숫자만 입력 가능합니다."
                                  },
                                  onChange: event =>
                                      handleChangeAmount(
                                          event.target.value
                                      )
                                }
                            )}
                            value={decimalFormat(
                                enterAmount
                            )}
                        />

                        <AmountUnit>
                          원
                        </AmountUnit>
                      </AmountInputWrap>

                      {errors.enterAmount && (
                          <ValidationMessage>
                            {
                              errors.enterAmount
                                  .message
                            }
                          </ValidationMessage>
                      )}
                    </FieldContent>
                  </FieldRow>

                  <FieldRow>
                    <FieldLabel>
                      비고
                    </FieldLabel>

                    <FieldContent>
                      <NoteInput
                          type="text"
                          value={note}
                          placeholder="비고를 입력해주세요."
                          onChange={event =>
                              setNote(
                                  event.target.value
                              )
                          }
                      />

                      <InputGuide>
                        지급·차감 사유나 참고할
                        내용을 입력할 수 있습니다.
                      </InputGuide>
                    </FieldContent>
                  </FieldRow>
                </InnerBox>

                {validation && (
                    <BottomValidation>
                      {validation}
                    </BottomValidation>
                )}

                <ModalFooter>
                  <SecondaryButton
                      type="button"
                      disabled={isSaving}
                      onClick={
                        handleBackToSearch
                      }
                  >
                    이전
                  </SecondaryButton>

                  <PrimaryButton
                      type="submit"
                      disabled={isSaving}
                  >
                    {isSaving
                        ? "처리 중"
                        : "이력 추가"}
                  </PrimaryButton>
                </ModalFooter>
              </form>
          )}
        </ModalBody>
      </ModalContainer>
  );
}

const ModalContainer = styled.div`
  width: 100%;
`;

const SearchOpenButton = styled.button`
  height: 40px;
  padding: 0 16px;
  border: 1px solid #f1d4c2;
  border-radius: 6px;
  background-color: #fff4e8;
  color: #f5811f;
  font-size: var(--font-size-14);
  font-weight: 600;
  cursor: pointer;

  &:hover {
    background-color: #ffe8d2;
  }
`;

const HistoryOpenButton = styled(
    SearchOpenButton
)`
  min-width: 104px;
`;

const SectionHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 14px;
`;

const SectionTitle = styled.div`
  margin-bottom: 5px;
  color: #222;
  font-size: var(--font-size-17);
  font-weight: 700;
`;

const SectionGuide = styled.div`
  color: #888;
  font-size: var(--font-size-13);
  line-height: 1.5;
`;

const ResultCount = styled.span`
  display: inline-flex;
  min-height: 24px;
  align-items: center;
  justify-content: center;
  padding: 0 9px;
  border: 1px solid #f1d4c2;
  border-radius: 12px;
  background-color: #fff4e8;
  color: #f5811f;
  font-size: var(--font-size-12);
  font-weight: 700;
`;

const InnerBox = styled.div`
  padding: 20px;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  background-color: #f9fafb;
`;

const FieldRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 20px;
  padding: 14px 0;
  border-bottom: 1px solid #eeeeee;

  &:first-child {
    padding-top: 0;
  }

  &:last-child {
    padding-bottom: 0;
    border-bottom: 0;
  }

  @media (max-width: 720px) {
    flex-direction: column;
    gap: 8px;
  }
`;

const FieldLabel = styled.div`
  width: 120px;
  min-width: 120px;
  padding-top: 10px;
  color: #444;
  font-size: var(--font-size-15);
  font-weight: 600;

  @media (max-width: 720px) {
    width: auto;
    min-width: 0;
    padding-top: 0;
  }
`;

const FieldContent = styled.div`
  display: flex;
  min-width: 0;
  flex: 1;
  flex-direction: column;
  gap: 9px;
`;

const SearchInputRow = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  gap: 8px;
`;

const SearchInput = styled.input`
  width: 100%;
  min-width: 0;
  height: 40px;
  padding: 0 13px;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  background-color: #fff;
  color: #444;
  font-size: var(--font-size-14);
  outline: none;

  &:focus {
    border-color: #f5811f;
  }

  &::placeholder {
    color: #aaa;
  }
`;

const SearchButton = styled.button`
  min-width: 74px;
  height: 40px;
  padding: 0 14px;
  border: 1px solid #f5811f;
  border-radius: 6px;
  background-color: #f5811f;
  color: #fff;
  font-size: var(--font-size-14);
  font-weight: 600;
  cursor: pointer;

  &:hover:not(:disabled) {
    background-color: #e97212;
  }

  &:disabled {
    border-color: #ddd;
    background-color: #ddd;
    cursor: not-allowed;
  }
`;

const InputGuide = styled.div`
  color: #999;
  font-size: var(--font-size-12);
  line-height: 1.45;
`;

const ValidationMessage = styled.div`
  color: #e03131;
  font-size: var(--font-size-13);
  line-height: 1.4;
`;

const TableBox = styled.div`
  width: 100%;
  overflow: hidden;
  border: 1px solid #e5e5e5;
  border-radius: 7px;
  background-color: #fff;
`;

const TableHeader = styled.div`
  display: grid;
  grid-template-columns:
    38px 1.2fr 1fr 1fr 0.9fr;
  min-width: 560px;
  min-height: 40px;
  align-items: center;
  padding: 0 42px 0 14px;
  border-bottom: 1px solid #e5e5e5;
  background-color: #f7f7f7;
  color: #666;
  font-size: var(--font-size-13);
  font-weight: 600;
  text-align: center;
`;

const TableBody = styled.div`
  max-height: 252px;
  overflow: auto;
  scrollbar-width: thin;
  scrollbar-color: #c7c7c7 transparent;

  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 999px;
    background-color: #c7c7c7;
  }
`;

const TableRow = styled.button`
  display: grid;
  width: 100%;
  grid-template-columns:
    38px 1.2fr 1fr 1fr 0.9fr;
  min-width: 560px;
  min-height: 48px;
  align-items: center;
  padding: 0 14px;
  border: 0;
  border-bottom: 1px solid #eeeeee;
  background-color:
          ${({$selected}) =>
                  $selected
                          ? "#fff4e8"
                          : "#fff"};
  color:
          ${({$selected}) =>
                  $selected
                          ? "#d96d12"
                          : "#555"};
  font-size: var(--font-size-13);
  text-align: center;
  cursor: pointer;

  &:last-child {
    border-bottom: 0;
  }

  &:hover {
    background-color: #fffaf6;
  }
`;

const TableCell = styled.span`
  overflow: hidden;
  padding: 0 7px;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const SelectedMarkCell = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SelectedMark = styled.span`
  position: relative;
  display: inline-block;
  width: 17px;
  height: 17px;
  box-sizing: border-box;
  border: 1px solid
  ${({$selected}) =>
          $selected
                  ? "#f5811f"
                  : "#ccc"};
  border-radius: 50%;
  background-color: #fff;

  &::after {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 9px;
    height: 9px;
    border-radius: 50%;
    background-color:
            ${({$selected}) =>
                    $selected
                            ? "#f5811f"
                            : "transparent"};
    content: "";
    transform: translate(-50%, -50%);
  }
`;

const EmptyResult = styled.div`
  min-width: 560px;
  padding: 34px 15px;
  color: #999;
  font-size: var(--font-size-13);
  text-align: center;
`;

const SelectedAdvertiserBox = styled.div`
  display: flex;
  min-height: 42px;
  align-items: center;
  gap: 12px;
  padding: 9px 12px;
  border-left: 3px solid #f5811f;
  border-radius: 0 6px 6px 0;
  background-color: #fff8f1;
`;

const SelectedAdvertiserLabel = styled.span`
  color: #999;
  font-size: var(--font-size-12);
`;

const SelectedAdvertiserValue = styled.span`
  color: #444;
  font-size: var(--font-size-14);
  font-weight: 700;

  span {
    margin-left: 7px;
    color: #999;
    font-size: var(--font-size-12);
    font-weight: 400;
  }
`;

const SelectedSummary = styled.div`
  display: grid;
  grid-template-columns:
    repeat(3, minmax(0, 1fr));
  overflow: hidden;
  margin-bottom: 14px;
  border: 1px solid #e5e5e5;
  border-radius: 7px;
  background-color: #fff;

  @media (max-width: 720px) {
    grid-template-columns: 1fr;
  }
`;

const SelectedSummaryItem = styled.div`
  min-width: 0;
  padding: 13px 15px;
  border-right: 1px solid #eeeeee;

  &:last-child {
    border-right: 0;
  }

  @media (max-width: 720px) {
    border-right: 0;
    border-bottom: 1px solid #eeeeee;

    &:last-child {
      border-bottom: 0;
    }
  }
`;

const SummaryLabel = styled.div`
  margin-bottom: 5px;
  color: #999;
  font-size: var(--font-size-12);
`;

const SummaryValue = styled.div`
  overflow: hidden;
  color:
          ${({$accent}) =>
                  $accent
                          ? "#f5811f"
                          : "#444"};
  font-size: var(--font-size-14);
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const PaymentMethodGrid = styled.div`
  display: grid;
  grid-template-columns:
    repeat(2, minmax(0, 1fr));
  gap: 9px;

  @media (max-width: 620px) {
    grid-template-columns: 1fr;
  }
`;

const PaymentMethodCard = styled.label`
  position: relative;
  display: flex;
  min-height: 72px;
  align-items: flex-start;
  gap: 10px;
  padding: 13px;
  border: 1px solid
  ${({$active}) =>
          $active
                  ? "#f5811f"
                  : "#e5e5e5"};
  border-radius: 7px;
  background-color:
          ${({$active}) =>
                  $active
                          ? "#fff8f1"
                          : "#fff"};
  cursor: pointer;

  input {
    position: absolute;
    opacity: 0;
    pointer-events: none;
  }
`;

const PaymentRadio = styled.span`
  position: relative;
  width: 18px;
  height: 18px;
  flex: 0 0 18px;
  box-sizing: border-box;
  margin-top: 1px;
  border: 1px solid
    ${({$active}) =>
    $active
        ? "#f5811f"
        : "#ccc"};
  border-radius: 50%;
  background-color: #fff;

  &::after {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color:
      ${({$active}) =>
    $active
        ? "#f5811f"
        : "transparent"};
    content: "";
    transform: translate(-50%, -50%);
  }
`;

const PaymentMethodText = styled.span`
  display: flex;
  flex-direction: column;
  gap: 5px;

  strong {
    color: #444;
    font-size: var(--font-size-14);
  }

  span {
    color: #999;
    font-size: var(--font-size-12);
    line-height: 1.4;
  }
`;

const AmountInputWrap = styled.div`
  position: relative;
  width: 100%;
  max-width: 420px;
`;

const AmountInput = styled.input`
  width: 100%;
  height: 40px;
  padding: 0 44px 0 13px;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  background-color: #fff;
  color: #444;
  font-size: var(--font-size-15);
  font-weight: 600;
  text-align: right;
  outline: none;

  &:focus {
    border-color: #f5811f;
  }
`;

const AmountUnit = styled.span`
  position: absolute;
  top: 50%;
  right: 14px;
  color: #888;
  font-size: var(--font-size-13);
  transform: translateY(-50%);
`;

const NoteInput = styled.input`
  width: 100%;
  height: 40px;
  padding: 0 13px;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  background-color: #fff;
  color: #444;
  font-size: var(--font-size-14);
  outline: none;

  &:focus {
    border-color: #f5811f;
  }

  &::placeholder {
    color: #aaa;
  }
`;

const BottomValidation = styled.div`
  margin-top: 10px;
  color: #e03131;
  font-size: var(--font-size-13);
  text-align: center;
`;

const ModalFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 18px;
`;

const SecondaryButton = styled.button`
  min-width: 96px;
  height: 38px;
  padding: 0 16px;
  border: 1px solid #dddddd;
  border-radius: 6px;
  background-color: #fff;
  color: #666;
  font-size: var(--font-size-14);
  font-weight: 600;
  cursor: pointer;

  &:hover:not(:disabled) {
    border-color: #f5811f;
    color: #f5811f;
  }

  &:disabled {
    background-color: #f5f5f5;
    color: #aaa;
    cursor: not-allowed;
  }
`;

const PrimaryButton = styled.button`
  min-width: 112px;
  height: 38px;
  padding: 0 18px;
  border: 1px solid #f5811f;
  border-radius: 6px;
  background-color: #fff4e8;
  color: #f5811f;
  font-size: var(--font-size-14);
  font-weight: 700;
  cursor: pointer;

  &:hover:not(:disabled) {
    background-color: #ffe8d2;
  }

  &:disabled {
    border-color: #dddddd;
    background-color: #f5f5f5;
    color: #aaaaaa;
    cursor: not-allowed;
  }
`;